import React from 'react';
import './App.css';
import Home from './pages/Index.js';


function App() {
  return (
    <div>
      <div className="largeYellowCircle"></div>
      <Home/>
    </div>
  );
}

export default App;
